/**
 * Feed API Service
 * 
 * Service layer for feed/timeline API calls
 */

import api from '../auth/apiClient';
import { FEED_API_CONFIG } from './apiConfig';
import { FeedResponse, FeedParams, Category, FilterOptions } from './types';

export class FeedApiService {
    /**
     * Fetch feed items with pagination and filters
     */
    static async fetchFeed(params: FeedParams = {}): Promise<FeedResponse> {
        const { page = 1, per_page = 10, category_id, job_level_id, author_name } = params;

        const response = await api.get<FeedResponse>(FEED_API_CONFIG.BASE, {
            params: {
                page,
                per_page,
                ...(category_id && { category_id }),
                ...(job_level_id && { job_level_id }),
                ...(author_name && { author_name }),
            },
        });

        return response.data;
    }

    /**
     * Fetch available categories
     */
    static async fetchCategories(): Promise<Category[]> {
        const response = await api.get<Category[]>(FEED_API_CONFIG.CATEGORIES);
        return response.data;
    }

    /**
     * Fetch filter options (job levels and users)
     */
    static async fetchFilterOptions(): Promise<FilterOptions> {
        const response = await api.get<FilterOptions>(FEED_API_CONFIG.OPTIONS);
        return response.data;
    }
}